export default {
    spaceFormattedNumber: '{{value, 0,0}}'
};
